<template>
  <div id="about">
    <sectionImage section="about" :text="header" :summary="summary"></sectionImage>
    <info :section="section" :language="language"></info>
  </div>
</template>

<script>
import sectionImage from '../SectionImage'
import info from './Info'

const SECTIONID = 8

export default {
  name: 'about',
  props: ['language', 'section'],
  components: {
    sectionImage,
    info
  },
  data () {
    return {
      header: '',
      summary: ''
    }
  },
  watch: {
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  methods: {
    handleLanguage: function () {
      this.header = this.$root.getHeader(SECTIONID)
      this.summary = this.$root.getSummary(SECTIONID)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/about/About.vue